import { AnnouncementPriority } from "@mimber/schema"

export const PRIORITY_OPTIONS = [
  { label: "Normal", value: AnnouncementPriority.NORMAL },
  { label: "Important", value: AnnouncementPriority.IMPORTANT },
  { label: "Urgent", value: AnnouncementPriority.URGENT },
]
